module.exports = __webpack_public_path__ + "img/1497932962.a9c4cba4.jpg";